module.exports = __webpack_public_path__ + "img/new_16.0f18f4c8.jpg";